<template>
  <div class="help" :class="{ fixed : cardActive }">
		<div class="action_bar"></div>
		<main>
			<h1>Workspace</h1>
<!-- 			{{ $store.state.workspaceItems }} -->

			<div class="label" v-for="patient in $store.state.workspaceItems" :title="patient.id" :key="patient.id">
				<div class="labelImage">
					<div class="label--number">{{ patient.id }}</div>
					<button class="label--image" @click="draftActions(), activePatient = patient.id, $store.commit('navBarMinimised', true)"></button>
				</div>
				<div class="patient_actions" v-if="patient.start_time || patient.end_time">
					<button class="patient_actions--time patient_actions--start_time" :class="{active : patient.start_time}" @click="$store.commit('addStartTime', { patientId: activePatient, time: currentTime }), cardActive = false">
						<span v-if="!patient.start_time">Start</span>
						<span v-if="patient.start_time">{{ patient.start_time }}</span>
					</button>
					<div class="time--link">→</div>
					<button class="patient_actions--time patient_actions--end_time" :class="{active : patient.end_time}" @click="$store.commit('addEndTime', { patientId: activePatient, time: currentTime }), cardActive = false">
						<span v-if="!patient.end_time">End</span>
						<span v-if="patient.end_time">{{ patient.end_time }}</span>
					</button>	
				</div>
			</div>

			<button class="text_only">Add placeholder patient</button>
    </main>

    <ModalCard :showComponents="cardActive" :layout="cardLayout" @updateStatus="cardActive = false, $store.commit('navBarMinimised', false)">
				<header>
					<div>Patient {{ activePatient }}</div>
					<button class="close" @click="cardActive = false, cardLayout = 'sheet', templatesActive = false, $store.commit('navBarMinimised', false)"></button>
				</header>
				<div class="sheet_options" :class="{ hide : templatesActive }">
					<ul class="set_time">
						<li class="set_time--start">
							<button @click="$store.commit('addStartTime', { patientId: activePatient, time: currentTime }), cardActive = 	false, $store.commit('navBarMinimised', false)">
								<div>Set start time</div>
								<div class="time start_time">{{ currentTime }}</div>
							</button>
						</li>
						<li class="set_time--end">
							<button @click="$store.commit('addEndTime', { patientId: activePatient, time: currentTime }), cardActive = 	false, $store.commit('navBarMinimised', false)">
								<div>Set end time</div>
								<div class="time end_time">{{ currentTime }}</div>
							</button>
						</li>
					</ul>
					<ul>
						<li class="border--bottom"><button>Add to group</button></li>
						<li><button>Start new claim</button></li>
						<li><button @click="cardLayout = 'panel', templatesActive = true">Start claim from template</button></li>
					</ul>
				</div>

				<div class="panel_templates" :class="{ template1 : template1Active }">
					<ul>
						<li><button class="list_item" style="color: #333">Template - Normal</button></li>
						<li><button class="list_item" style="color: #333">Template - Code + diagnosis combos</button></li>
						<li><button class="list_item" style="color: #333">Template - One choice</button></li>
						<li><button class="list_item" @click="template1Active = true">Template - Full template</button></li>
					</ul>

					<div class="panel_templates--template1">
						<div class="group slide_up--actions--template1">
							<h5>Date</h5>
							<div class="date_picker">
								<button class="date_picker--previous"></button>
								<div class="date_picker--date">{{ getLastUsedDate() }}</div>
								<button class="date_picker--next" :disabled="$store.state.lastUsedDate == 'Today'" @click="$store.commit('incrementDate')"></button>
							<!-- <button class="date_picker--next" :disabled="$store.state.lastUsedDate == 'Today'" @click="$store.commit('incrementDate'), labelSnapTaken = false"></button> -->
							</div>
						</div>
					
						<button class="primary slide_up_primary">Save</button>
						<!-- <button class="primary slide_up_primary" @click="$store.commit('navBarModalActive', false), slideUpTemplate1 = false, viewLabelSnap = false, labelSnapTaken = false, labelSnapStandalone = false, viewToast = true">Save</button> -->
					</div>
				</div>
    </ModalCard>

  </div>
</template>


<script>
import ModalCard from '@/components/ModalCard.vue'

export default {
	components: {
		ModalCard,
	},
	data: function () {
    return {
			labelCount: 1,
			activePatient: 0,
			cardActive: false,
			cardLayout: 'sheet',
			templatesActive: false,
			template1Active: false,
    }
  },
  methods: {
		draftActions() {
			this.cardActive = true;
		},
		getLastUsedDate() {
			var $date = this.$store.state.lastUsedDate;

			if ( $date == 'Today') {
        return $date;
      } else {
        return $date.substring(0, $date.length - 5);
      }
		},
  },
  computed: {
		currentTime() {
			var d = new Date();
			var h = d.getHours();
			var m = String(d.getMinutes()).padStart(2, "0");
			return h + ":" + m;
		},
  },
}
</script>


<style scoped>
.help {
	-webkit-overflow-scrolling: touch;
	bottom: 0;
	left: 0;
	overflow-y: scroll;
	padding-bottom: calc(3rem + env(safe-area-inset-bottom));
	position: fixed;
	right: 0;
	top: 0;
}
.help.fixed {
	z-index: 1200;
}

main {
	padding: 0 1rem 1rem;
}
h1 {
	font-weight: 700;
	margin-bottom: 1.5rem;
}


li.border--top {
	border-top: 1px solid #999;
}


.label {
	margin-top: 1rem;
}
.labelImage {
	align-items: center;
	display: flex;
}
.label--number {
	font-weight: 600;
	width: 1.5rem;
}
.label--image {
	background: url('/img/index_card.jpg') no-repeat center center;
	background-size: cover;
	/*border-radius: 4px 4px 0 0;*/
	padding-bottom: 32%;
	width: calc(100% - 1.5rem);
}
.patient_actions {
	background-color: #f3f3f3;
	border-radius: 0 0 8px 8px;
	display: flex;
	/*height: 40px;*/
	margin-bottom: 1rem;
	margin-left: 1.5rem;
	padding: 0.5rem;
	width: calc(100% - 1.5rem);
}
.patient_actions--time {
	align-items: center;
	border-radius: 4px;
	display: flex;
	font-size: 15px;
	height: 28px;
	line-height: 28px;
	opacity: 0.2;
	padding-left: 1.5rem;
	padding-right: 0.25rem;
}
.patient_actions--start_time {
	background: rgba(144,19,254,0.1) url('/img/icon--timer--start.svg') no-repeat 0.125rem center;
	background-size: 20px 20px;
	color: #9013FE;
}
.patient_actions--end_time {
	background: rgba(0,0,0,0.06) url('/img/icon--timer--end.svg') no-repeat 0.125rem center;
	background-size: 20px 20px;
}
.patient_actions--start_time.active,
.patient_actions--end_time.active {
	opacity: 1;
}
.time--link {
	color: #aaa;
	line-height: 28px;
	padding-left: 0.25rem;
	padding-right: 0.25rem;
}



.actions header {
  align-items: center;
  background-color: #fff;
  border-bottom: 0.5px solid #ccc;
  border-radius: 16px 16px 0 0;
  color: #999;
  display: flex;
  font-weight: 600;
  height: 56px;
  justify-content: space-between;
  padding-left: 1rem;
  text-transform: uppercase;
}
.actions header button.close {
  background: url('/img/icon--delete.svg') no-repeat center center;
  background-size: 20px 20px;
  height: 48px;
  width: 48px;
}
.actions ul {
	/*border-color: #aaa;*/
	padding-bottom: 0.5rem;
	padding-top: 0.5rem;
}
.actions li {
	border: none;
}
.actions li.border--bottom {
	border-bottom: 0.5px solid #ccc;
	margin-bottom: 0.5rem;
	padding-bottom: 0.5rem;
}
.actions button {
	align-items: center;
	color: var(--blue);
	display: flex;
	height: 48px;
	justify-content: space-between;
	padding-left: 1rem;
	padding-right: 1rem;
	width: 100%;
}

.actions li.border--top {
	border-top: 1px solid #999;
}
.time {
	border-radius: 40px;
	/*color: #fff;*/
	font-size: 18px;
	font-weight: 600;
	letter-spacing: 1px;
	padding: 0.375rem 0.75rem;
}
.start_time {
	background: rgba(144,19,254,0.1) url('/img/icon--time--start.svg') no-repeat 0.5rem center;
	color: rgba(144,19,254,1);
	padding-left: 3rem;
}
.end_time {
	background: #e6e6e6 url('/img/icon--time--end.svg') no-repeat 0.5rem center;
	color: #333;
	padding-left: 3rem;
}

ul.set_time {
	border-top: none;
	display: flex;
	padding-bottom: 0;
	padding-top: 0;
}
.set_time li {
	width: 50%;
}
.set_time li button {
	flex-direction: column;
	height: auto;
	padding-bottom: 0.625rem;
	padding-top: 0.5rem;
}
.set_time li.set_time--start button {
	border-right: 0.5px solid #ccc;
}
.set_time li button div:first-of-type {
	font-size: 13px;
	font-weight: 600;
	margin-bottom: 0.375rem;
	text-transform: uppercase;
}
.set_time li:first-of-type button div:first-of-type {
	color: rgba(144,19,254,0.7);
}
.set_time li:last-of-type button div:first-of-type {
	color: #999;
}


/*PANEL TEMPLATES*/
.panel_templates {
	display: flex;
	transition: 0.3s all ease;
	width: 200vw;
}
.panel_templates.template1 {
	transform: translateX(-100vw);
}
.panel_templates ul {
	border: none;
	display: block;
	width: 100vw;
}


/*PANEL TEMPLATES - TEMPLATES 1*/
.panel_templates--template1 {
	/*position: absolute;
	left: 100%;*/
	width: 100vw;
}
.panel_templates--template1 h5 {
	font-size: 14px;
	line-height: 1em;
	margin-top: 1rem;
	text-align: center;
	text-transform: uppercase;
}
.date_picker {
	align-items: center;
	display: flex;
	justify-content: space-between;
	margin-right: -12px;
	width: 160px;
}
button.date_picker--previous {
	background: url('/img/icon--minus.svg') no-repeat center center;
	height: 48px;
	width: 48px;
}
button.date_picker--next {
	background: url('/img/icon--add--active.svg') no-repeat center center;
	height: 48px;
	width: 48px;
}
.date_picker button[disabled=disabled] {
	background: url('/img/icon--add--disabled.svg') no-repeat center center;
	opacity: 0.4;
}

.date_picker {
	font-size: 32px;
	height: auto;
	justify-content: center;
	margin-bottom: 2rem;
	width: 100%;
}
.date_picker--date {
	text-align: center;
	width: 100px;
}
button.date_picker--previous,
button.date_picker--next {
	background-size: 32px 32px;
	height: 48px;
	width: 48px;
}

button.slide_up_primary {
	border-radius: 8px;
	justify-content: center;
	margin-left: 1rem;
	text-align: center;
	width: calc(100% - 2rem);
}


.text_only {
	bottom: 4rem;
	color: var(--blue);
	height: 48px;
	position: absolute;
	width: calc(100% - 2rem);
}


/*TRANSITION TO PANEL*/
.sheet_options {

}
.sheet_options.hide {
	display: none;
}
</style>
